import React from 'react'
import NoContent from "./NoContent";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';
import { isString } from "underscore";
import NavigateToPDP from '../Global/Product/NavigateToPDP';
import AxiosIndicatorRunTimeLoader from '../AxiosIndicatorRunTimeLoader';

const ProductSearch = (props) => {
    const { productList, searchTerm, apiCall } = props;
    const [__check] = useAxiosIndicatorCheck();

    const getSearchStringBold = (string) => {
        return (
            <>
                {isString(string) && (
                    <div className="ellipses" dangerouslySetInnerHTML={{
                        __html: string.toUpperCase().replaceAll(
                            searchTerm.toUpperCase(), "<strong>" + searchTerm.toUpperCase() + "</strong>"
                        ),
                    }} />
                )}
            </>
        );
    };

    return (
        <>
            <div className="search-item-title">
                RECOMMENDED PRODUCTS
            </div>
            {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Product ?
                <AxiosIndicatorRunTimeLoader />
                :
                <>
                    {Object.keys(productList).length > 0 ?
                        <>
                            <div className="search-product-list">
                                {Object.keys(productList).map((p, i) => (
                                    <React.Fragment key={p}>
                                        {i < 5 && (
                                            <div className="search-product-list-item">
                                                <div className="search-product-list-item-info">
                                                    <NavigateToPDP
                                                        data={{
                                                            ManufacturerName: productList[p]?.ManufacturerName,
                                                            ERPMFRPartNumber: productList[p]?.ERPMFRPartNumber,
                                                            ItemNumber: productList[p]?.ItemNumber,
                                                            searchTerm: searchTerm
                                                        }}>
                                                        <div className="search-product-list-item-title">
                                                            {getSearchStringBold(
                                                                Helper.valueIsNotNull(productList[p].ERPMFRPartNumber)
                                                                    ? productList[p].ERPMFRPartNumber
                                                                    : ""
                                                            )}
                                                        </div>
                                                    </NavigateToPDP>
                                                    <div className="search-product-list-item-subtitle">
                                                        {getSearchStringBold(productList[p].ManufacturerName)}
                                                    </div>
                                                    <div className="search-product-list-item-desc">
                                                        {getSearchStringBold(productList[p].ShortDescription)}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                            <div className="text-center mt-auto pb-3" >
                                <a href={void 0} className="bs5 btn btn-sm btn-primary w240"
                                    onClick={() => { props.onProductSearch(); }}>
                                    VIEW ALL PRODUCT RESULTS
                                </a>
                            </div>
                        </>
                        :
                        <NoContent />
                    }
                </>
            }
        </>
    )
}

export default ProductSearch